
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

/** Tooltip Code **/
const HoverTooltip = withStyles((theme) => ({
	tooltip: {
	  backgroundColor: '#000000',
	  color: '#ffffff',
	  fontStyle: 'normal',
	  textAlign: 'center',
	  display: 'block',
	  maxWidth: 240,
	  fontSize: theme.typography.pxToRem(14),
	  border: '1px solid #000000',
	},
	arrow: {
		color: '#000000',
	},
	tooltipPlacementTop: {
		right: "0px",
		top: "20px",
	},
	tooltipPlacementBottom: {
		right: "0px",
		top: "-25px",
	},
	
}))(Tooltip);

export default HoverTooltip